import { render, staticRenderFns } from "./GBoothEditHeader.vue?vue&type=template&id=b50f2688&"
import script from "./GBoothEditHeader.vue?vue&type=script&lang=ts&"
export * from "./GBoothEditHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports